export default __webpack_public_path__ + "static/20-b5ca7714c91819f04e7dc8d9b41f5136.jpg";